module.exports = __webpack_public_path__ + "static/image004-4d5d57f85b7aeb2d19d74c7d1a3c4f07.jpg";